export default "__VITE_ASSET__uRnYF0Af__"